import angular from 'angular';
import BANKS from 'JSON/banks';
import COUNTRIES from 'JSON/countries';
import FAQ from 'JSON/ssp_faq';
import SSP_ENGLISH from 'Languages/ssp_english';
import SSP_KOREAN from 'Languages/ssp_korean';

import 'flickity/dist/flickity.min.css';
const Flickity = require('flickity/js');

require('flickity-imagesloaded');
require('flickity-fullscreen');

(function() {
    'use strict';

    angular.module('app').component('ssp', {
        template: require('./ssp.html'),
        controller: Controller,
        controllerAs: 'vm'
    });

    Controller.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'QueryService',
        'SessionService',
        'ModalService',
        'LanguageService',
        'logger'
    ];

    function Controller(
        $scope,
        $state,
        $stateParams,
        QueryService,
        SessionService,
        ModalService,
        LanguageService,
        logger
    ) {
        var vm = this;
        vm.language = localStorage.getItem('language') || 'korean';
        vm.strings = vm.language == 'korean'?SSP_KOREAN:SSP_ENGLISH;

        vm.pages = [{
            english_text: 'Request a Certificate',
            korean_text: '수료증 발급 신청',
            _image: 'certificate',
            func: page_request_certificate
        },{
            english_text: 'Change my Class Schedule',
            korean_text: '수업 시간 변경',
            _image: 'reschedule',
            func: reschedule.bind(null, 2)
        },{
            english_text: 'Transfer my Class to a New Teacher',
            korean_text: '담당 선생님 변경',
            _image: 'transfer',
            func: reschedule.bind(null, 1)
        },{
            english_text: 'Rate my Teacher’s Performance',
            korean_text: '선생님 수업 평가',
            _image: 'rate',
            func: go_to_rating
        },{
            english_text: 'Report a Problem',
            korean_text: '문제 신고',
            _image: 'report',
            func: report_a_problem
        },{
            english_text: 'Request a Refund',
            korean_text: '환불 신청',
            _image: 'refund',
            func: mark_for_refund
        }];

        vm.banks = BANKS;
        vm.countries = COUNTRIES;
        vm.faq = FAQ;

        vm.test = () => {
            console.log(vm.faq_main);
        }

        vm.pages.forEach(p => {
            p.image = require(`Images/ssp2/${p._image}.svg`);
        });

        vm.id = $stateParams.id;

        if(vm.id){
            get_data();
        }

        function get_data(){
            const params = {};
            var request = {
                method: 'GET',
                route: { 'regular_class_item': vm.id, 'regular_class':'' },
            };

            QueryService.query(request).then(
                function(response) {

                    vm.item = response.data.data.data[0];
                    console.log(vm.item);
                    if(!vm.item){
                        $state.go('.', { id: null })
                    }else{
                        vm.email = vm.item.student_email;
                    }

                    vm.semesters_array = [];
                    const completed_semesters = Math.floor(vm.item.attended / (vm.item.class_count / vm.item.semesters))
                    for(var i = 0; i < completed_semesters; i++){
                        vm.semesters_array.push(i+ 1);
                    }
                    // vm.semester = vm.semesters_array[0];
                    vm.completed_semesters = completed_semesters;
                    console.log(vm.completed_semesters);
                    vm.semester = '1';
                },
                function(err) {
                    logger.error('Invalid Class code');
                    $state.go('.', { id: null })
                }
            );

        }


        vm.get_ssp_link = () => {
            const params = {};
            var request = {
                method: 'GET',
                route: { 'regular_class/class_code': vm.class_code },
            };

            QueryService.query(request).then(
                function(response) {
                    vm.id = response.data.data.id;
                    console.log(vm.id);
                    if(vm.id){
                        $state.go('.', { id: vm.id })
                    }
                },
                function(err) {
                    logger.error('Invalid Class code');
                }
            );
        };

        vm.reschedule = reschedule;
        function reschedule(page, cb){
            console.log(page)
            // vm.item.reason = vm.reason
            var modal = {
                teacher: vm.item,
                page: page,
                email: vm.email,
                name: vm.item.student_name || vm.name,
                cb: cb
            };

            ModalService.reschedule_modal(modal, vm.TPLS).then(
                function(response) {
                },
                function(error) {
                    logger.errorFormatResponse(error);
                }
            );
        }

        function go_to_rating(){
            $state.go('rating-page2', {id: $stateParams.id })
        }

        vm.mark_for_refund = mark_for_refund;
        function mark_for_refund(){
            vm.confirming_refund = 1;
            vm.submitting_refund = 0;
            vm.refund = {};
        };

        // vm.refund =
        // {
        //     "email": "urbanpanda182@gmail.com",
        //     "english_name": "Kang Hanna",
        //     "korean_name": "강한나",
        //     "bank": "Daewoo Securities (대우증권)",
        //     "bank_account_number": "00123193579",
        //     "bank_account_name": "09396146528",
        //     "country": "Republic of Korea (South Korea)",
        //     "city": "seouli",
        //     "address1": "address 1",
        //     "address2": "address 2",
        //     "zipcode": "001239"
        // };

        vm.actual_mark_for_refund = () => {

            function start(){
                vm.loading = true;
                var request = {
                    method: 'POST',
                    body: { refund: vm.refund },
                    params: false,
                    hasFile: false,
                    route: { refund: vm.item.regular_class_id },
                    cache: false
                };

                QueryService.query(request)
                    .then(
                        function(response) {
                            vm.confirming_refund = 0;
                            logger.success(`Successfully Marked for Refund`);

                            if(vm.submit_problem_callback){
                                vm.submit_problem_callback();
                            }

                        },
                        function(error) {
                        }
                    )
                    .finally(function() {
                        vm.loading = false;
                    });
            }

        }
        
        vm.click_page = page => {
            if(page.func){
                page.func();
            }
        }

        vm.page_request_certificate;
        function page_request_certificate(){
            
            vm.requesting_certificate = 1;

        }

        vm.submit_cert_request = submit_cert_request;
        function submit_cert_request(){

            vm.loading = true;

            var request = {
                method: 'GET',
                route: { 'certificate': vm.item.regular_class_id },
                params: { name: vm.item.student_name, semester: vm.semester, email: vm.email }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.thankyou = 1;
                        vm.requesting_certificate = 0;
                        // getData();
                    },
                    function(error) {
                        logger.error(error.data.message);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

        }

        function report_a_problem(){
            vm.reporting_problem = 1;
        }

        vm.click_problem = (problem) => {
            vm.problem = problem;
            setTimeout(()=> {
                document.getElementById('probdesc').scrollIntoView({
                    behavior:'smooth'
                })
                document.getElementById('probdesc').focus();
            }, 10);
        }

        vm.unclick_problem = () => {
            vm.problem = null;
        }

        vm.submit_question = () => {

            const required = [
                { id:'question_faq', model: 'faq_main' },
                { id:'question_name', model: 'name' },
                { id:'question_email', model: 'email' },
                { id:'question_text', model: 'problem_description' }
            ]

            function start(){

                const body = {
                    type: 'questions',
                    complaint_text: vm.faq_main.english_text + ' - ' + vm.problem_description,
                }
                
                var request = {
                    method: 'POST',
                    body,
                    params: { email: vm.email, name: vm.name },
                    route: { complaint: '' },
                };

                QueryService.query(request)
                    .then(
                        function(response) {
                            vm.thankyou = 1;
                        },
                        function(error) {
                            logger.errorFormatResponse(error);
                        }
                    )
                    .finally(function() {
                        vm.loading = false;
                    });
            }

            if(!vm.name || !vm.email || !vm.faq_main || !vm.problem_description){
                vm.submit_failed = 1;

                vm.sf_timeout = setTimeout(()=>{
                    vm.submit_failed = 0;
                    $scope.$apply();
                }, 3000);

                for(let i = 0; i < required.length; i++){
                    const r = required[i];
                    if(!vm[r.model]){
                        document.getElementById(r.id).focus();
                        break;
                    }
                }

            }else{
                start();
            }


        }

        vm.submit_problem = () => {
            
            function start(){
                const body = {
                    type: 'complaint',
                    session_id: vm.id,
                    complaint_id: vm.problem.id,
                    complaint_text: vm.problem_description,
                    resolution_type: vm.resolution_type,
                    teacher_name: vm.item.name
                }
                
                const params = { email: vm.email || vm.item.student_email, name: vm.item.student_name || vm.name }; 


                var request = {
                    method: 'POST',
                    body,
                    params: vm.resolution_type == 'refund' || vm.resolution_type == 'change_teacher'?null: params,
                    route: { complaint: '' },
                };

                QueryService.query(request)
                    .then(
                        function(response) {
                            vm.thankyou = 1;
                        },
                        function(error) {
                            logger.errorFormatResponse(error);
                        }
                    )
                    .finally(function() {
                        vm.loading = false;
                    });

            }


            if(!vm.problem_description){
                
                const required = [
                    { id:'probdesc', model: 'problem_description' },
                ];
                
                if(!vm.problem_description){
                    vm.submit_failed = 1;

                    vm.sf_timeout = setTimeout(()=>{
                        vm.submit_failed = 0;
                        $scope.$apply();
                    }, 3000);

                    for(let i = 0; i < required.length; i++){
                        const r = required[i];
                        if(!vm[r.model]){
                            document.getElementById(r.id).focus();
                            break;
                        }
                    }
                }
            }else{


                if(vm.resolution_type == 'refund'){
                    vm.submit_problem_callback = start;
                    vm.mark_for_refund();
                    vm.refund.refund_reason_type = 'Teacher Problem';
                }else{
                    vm.submit_problem_callback = null;
                }

                if(vm.resolution_type == 'change_teacher'){
                    reschedule(1, (r) => {
                        console.log(r, 'asdkja');
                        start();
                    });
                }

            }

        }

        vm.get_complaints = function(){

            var request = {
                method: 'GET',
                route: { 'lookup-complaint': '' },
                params: { new_complaints: 1 }
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.complaints = response.data.data.items;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

        }
        vm.get_complaints();

        // vm.confirming_refund = 1;
        // vm.thankyou = 1;
        // vm.expired = 1;
        // vm.reporting_problem = 1;
        vm.back_from_thankyou = () => {
            vm.thankyou = 0;

            vm.confirming_refund = 0;
            vm.thankyou = 0;
            vm.expired = 0;
            vm.reporting_problem = 0;
        }

        vm.back_from_expired = () => {
            $state.go('.', { id: null })
        }

        vm.submit_refund = () => {
            
            const required = [
                { id:'vm.refund.refund_reason_type', model: 'refund_reason_type' },
                { id:'vm.refund.email', model: 'email' },
                { id:'vm.refund.english_name', model: 'english_name' },
                { id:'vm.refund.bank', model: 'bank' },
                { id:'vm.refund.bank_account_number', model: 'bank_account_number' },
                { id:'vm.refund.bank_account_name', model: 'bank_account_name' },
                { id:'vm.refund.country', model: 'country' },
                { id:'vm.refund.city', model: 'city' },
                { id:'vm.refund.address1', model: 'address1' },
                { id:'vm.refund.zipcode', model: 'zipcode' },
            ];
            

            let has_all_required = true;
            
            for(let i = 0; i < required.length; i++){
                const r = required[i];
                if(!vm.refund[r.model]){
                    has_all_required = false;
                }
            }

            if(!has_all_required){
                vm.submit_failed = 1;

                vm.sf_timeout = setTimeout(()=>{
                    vm.submit_failed = 0;
                    $scope.$apply();
                }, 3000);

                for(let i = 0; i < required.length; i++){
                    const r = required[i];
                    if(!vm.refund[r.model]){
                        if(r.model == 'refund_reason_type'){
                            document.getElementById(r.id).scrollIntoView();
                        }
                        document.getElementById(r.id).focus();
                        break;
                    }
                }
            }else{

                
                vm.submitting_refund = 1;
                
                window.scroll({
                    top: 0, 
                    left: 0, 
                    behavior: 'smooth'
                });
            }
        }

        vm.toggle_language = () => {
            localStorage.setItem('language', vm.language == 'korean'?'english':'korean');
            vm.language = localStorage.getItem('language');
            vm.strings = vm.language == 'korean'?SSP_KOREAN:SSP_ENGLISH;
            
        }

        vm.where_class_code_f = () => {
            vm.where_class_code = 1;
            setTimeout(() => {
                const where_class_code = document.getElementById('where_class_code')
                where_class_code.scrollIntoView({behavior: 'smooth'})
            }, 10);
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/ssp/ssp.component.js